import { Alert, Box, LinearProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import Contents from '../Contents'
import moment from 'moment'
import getMedicineAlarm from '../getMedicineAlarm'

const ViewContents = ({ drugBag, setView, requiredDrugs }) => {
  const [loading, setLoading] = useState(true)
  const [medicines, setMedicines] = useState([])
  const [contentSummary, setContentSummary] = useState([])
  const [bagLevels, setBagLevels] = useState([])
  const [fetchError, setFetchError] = useState(false)

  const contentsSummaryFn = () => {
    try {
      let Ar = []
      for (const drug of medicines) {
        const i = Ar.findIndex((e) => e._id === drug.medicine._id)
        if (i > -1) {
          Ar[i].qty++
          Ar[i].expiry =
            moment(Ar[i].expiry) < moment(drug.expiry)
              ? Ar[i].expiry
              : drug.expiry
        } else {
          Ar.push({
            name: drug.medicine.title,
            _id: drug.medicine._id,
            expiry: drug.expiry,
            qty: 1,
            alarm: getMedicineAlarm(drug.medicine, drugBag, bagLevels),
            presentation: drug.medicine.presentation,
            constitution: drug.medicine.constitution,
          })
        }
      }
      const sortedAr = Ar.sort((a, b) =>
        a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
      )
      setContentSummary(sortedAr)
    } catch {
      setContentSummary([])
    }
  }

  useEffect(() => {
    if (!drugBag?._id) return

    API.get('/medsmx/bag-contents?id=' + drugBag._id)
      .then((res) => {
        setMedicines(res.data?.contents)
        setBagLevels(res.data?.bagLevels ?? [])
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [drugBag?._id])

  useEffect(() => {
    contentsSummaryFn()
  }, [medicines, drugBag, bagLevels])

  return (
    <Box width="100%">
      {loading ? (
        <LinearProgress />
      ) : fetchError ? (
        <Alert severity="error">
          Unable to load bag contents. Please try again later.
        </Alert>
      ) : (
        <Contents
          contentSummary={contentSummary}
          allDrugs={medicines}
          requiredDrugs={requiredDrugs}
          noClick
        />
      )}
    </Box>
  )
}

export default ViewContents
